import React from "react";
import CreatePodcastForm from "../components/Podcast/CreatePodcastForm";

function CreatePodcast() {
  return (
    <div className="input-wrapper">
      <CreatePodcastForm />
    </div>
  );
}

export default CreatePodcast;
